import { createStore } from 'redux';
import { settingReducers } from '../redux/reducers/settings'

export const store = createStore(settingReducers);